import type {Content, KeyTextField} from '@prismicio/client'
import type {CategoryIntegrations} from './userGetIntegrations'

const normalizeCategoryName = (name: KeyTextField): string => (name ?? '').trim().toLowerCase()

// Documents saved before these fields existed come back without them
export const getExtraCategories = ({
  extra_categories = [],
  extra_integrations = [],
}: Partial<Pick<Content.IntegrationsContainerSliceV2Primary, 'extra_categories' | 'extra_integrations'>>): Array<
  CategoryIntegrations & {name: string}
> =>
  extra_categories
    .filter(({category_name}) => normalizeCategoryName(category_name) !== '')
    .map(({category_name, title}) => ({
      name: category_name!.trim(),
      title,
      integrations: extra_integrations
        .filter(({category}) => normalizeCategoryName(category) === normalizeCategoryName(category_name))
        .map(({logo, name, description, link}) => ({logo, name, description, link})),
    }))
    .filter(({integrations}) => integrations.length > 0)
